<template>
    <div
        class="tile-grid"
        @click="openEventId=null">
        <EventEntryTile
            v-for="event in events"
            :key="'event-tile-' + event.id"
            :event="event"
            :open="event.id === openEventId"
            :hide-categories="hideCategories"
            @open="openEventId = $event" />
        <div
            v-for="n in showNumberOfLoadingEntries"
            :key="n">
            <EventEntryLoadingDummy />
        </div>
    </div>
</template>

<script>
import EventEntryLoadingDummy
    from "@/components/pages/eventIFrame/EventEntry/EventEntryOverview/EventEntryLoadingDummy";
import EventEntryTile from "@/components/pages/eventIFrame/EventEntry/EventEntryTiles/EventEntryTile";

export default {
    name: "IFrameEventTiling",
    components: {
        EventEntryTile, EventEntryLoadingDummy
    },
    props: {
        events: {
            type: Array,
            required: true
        },
        iFrameType: {
            type: String,
            required: true
        },
        showNumberOfLoadingEntries: {
            type: Number,
            default: 0
        },
        showingSingleEvent: {
            type: Boolean,
            default: false
        },
        hideCategories: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            openEventId: null
        }
    },
    mounted() {
        this.$emit('hook:mounted')
    }
}
</script>

<style lang="scss" scoped>
.tile-grid {
    display: grid;
    gap: map-get($spacers, 4);
    grid-template-columns: 1fr;
}

@include media-breakpoint-up(sm) {
    .tile-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@include media-breakpoint-up(lg) {
    .tile-grid {
        grid-template-columns: 1fr 1fr 1fr;
    }
}

@include media-breakpoint-up(xl) {
    .tile-grid {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
}

</style>
